import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'sa-ui';
import sortBy from 'lodash/sortBy';

import './ReportBarChart.scss';

import Label from './Label';

import * as helpers from './reportHelpers';

const ReportBarChart = (props) => (
  <Card style={{ width: '100%' }} className="chart-mobile report-bar-chart--container">
    <div style={{ color: props.titleColor }}>
      <strong>
        <i className="pe-7s-graph1 mr-2" />
        {props.title}
        {props.isStudentTRI && props.area && (
          <div style={{ color: '#8d8d8d' }}>{props.area[0].studentName}</div>
        )}
      </strong>
    </div>
    {
      (props.area || props.schools) && (
        <Label
          isReportTRI={props.isReportTRI}
          isStudentTRI={props.isStudentTRI}
          avgByAreaMessage={props.avgByAreaMessage}
          isSchoolView={props.isSchoolView}
          isApplicationView={props.isApplicationView}
          isAvgGeneral={props.avgGeneral}
          isGradeGroupAvgView={props.isGradeGroupAvgView}
        />
      )
      // <div className="labelAvgMessage">
      //   {props.avgByAreaMessage}:
      //   <div className="redLine"></div>
      // </div>
    }
    <div style={{ marginTop: '60px' }}>
      <div
        className="report-bar-chart flexArea"
        style={{
          margin: props.area ? '20px 0 60px' : '20px 0',
          justifyContent:
            (props.area || props.schools) && !props.isStudentTRI ? 'flex-start' : 'center',
        }}
      >
        {props.area && props.avgGeneral && (
          <div className="avgGeneral" style={{ bottom: props.avgGeneral / 1.65 }}>
            <span>{props.avgGeneral}</span>
          </div>
        )}
        {props.schools.length > 0 && props.averageSchools && (
          <div className="avgArea" style={{ bottom: props.averageSchools * 3.5 - 1 }}>
            <span>{props.averageSchools}</span>
          </div>
        )}
        {props.schools.length > 0 &&
          props.schools
            .filter((s) => s.gradeAvg > 0 || s.average > 0 || s.grade > 0)
            // .slice(columnsStart, columnsLimit)
            .map((s, index) => (
              <div className="bar-wrapper">
                <div
                  className="value"
                  style={{ color: helpers.getColor(s.gradeAvg || s.average || s.grade) }}
                >
                  {s.gradeAvg || s.average || s.grade}%
                </div>
                <div
                  className="bar"
                  style={{
                    height: s.gradeAvg * 3.5 || s.average * 3.5 || s.grade * 3.5,
                    backgroundColor: helpers.getColor(s.gradeAvg || s.average || s.grade),
                    maxWidth: '25px',
                  }}
                />
                <div className="description">
                  {s.levelName || s.name || s.nameSchool || s.group}
                </div>
              </div>
            ))}

        {!props.isStudentTRI &&
          props.area &&
          props.area.length > 0 &&
          props.area.map((el) => (
            <div className="flexArea">
              <div className="block-description">
                <div className="description area">{el.area}</div>
              </div>
              <div className="block-chart" style={{ marginTop: '20px' }}>
                {!props.isApplicationView && (
                  <div className="avgArea" style={{ bottom: (el.avgGroup || el.avgSchool) / 2 }}>
                    <span>{el.avgGroup || el.avgSchool}</span>
                  </div>
                )}
                {el.results &&
                  el.results.map((r, index) => (
                    <div className="bar-wrapper" style={{ marginLeft: index === 0 && '80px' }}>
                      <div className="value" style={{ color: helpers.getStudentColor(index) }}>
                        {r.percentage}
                      </div>
                      <div
                        className="bar"
                        style={{
                          height: r.percentage / 2,
                          backgroundColor: helpers.getStudentColor(index),
                          maxWidth: '25px',
                        }}
                      />
                      <div className="description">{/* {r.studentName} */}</div>
                      <div className="nameToolTip">{`${
                        r.studentName || r.groupName || r.schoolName
                      } - ${el.area}`}</div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        {props.isStudentTRI &&
          props.area &&
          props.area.length > 0 &&
          props.area.map((el) => (
            <div className="flexArea">
              <div className="block-chart">
                {el.results.map((r, index) => (
                  <div className="bar-wrapper" style={{ paddingLeft: '80px' }}>
                    <div
                      className="avgArea student"
                      style={{ bottom: r.application / 2, right: '0' }}
                    >
                      <span>{r.application}</span>
                    </div>
                    <div className="value" style={{ color: helpers.getStudentColor(index) }}>
                      {r.percentage}
                    </div>
                    <div
                      className="bar"
                      style={{
                        height: r.percentage / 2,
                        backgroundColor: helpers.getStudentColor(index),
                        maxWidth: '25px',
                      }}
                    />
                    <div className="description">{r.area}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  </Card>
);
ReportBarChart.propTypes = {};

ReportBarChart.defaultProps = {
  schools: [],
  title: '',
};

export default ReportBarChart;
